import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Dropdown, Menu, message, Modal, Spin } from "antd";
import { AuthCheck, AUTH_ACTIONS } from "authorization";
import { RECORD_STATE } from "Constants";
import { createComponentStore, useStoreState } from "easy-peasy";
import React, { useEffect, useState } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import AbolishModal from "Pages/private/transactions/contracts/components/abolish-modal";
import { ACTION_TYPES, ContractStoreModel } from "store/models/contracts";

const useContractStore = createComponentStore(ContractStoreModel);

export default function ContractOperations({
  record,
  onOperationExecuted,
  ...props
}) {
  const history = useHistory();
  const match = useRouteMatch();

  const { abilities } = useStoreState((store) => store.auth);
  const [store, actions] = useContractStore();

  const { process } = store;
  const [abolishModalVisible, setAbolishModalvisible] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  useEffect(() => {
    switch (process) {
      case ACTION_TYPES.REMOVED_DATA:
        message.success("Sözleşme kaldırıldı.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.RESTORED_DATA:
        message.success("Sözleşme arşivden geri alındı.");
        onOperationExecuted();
        break;
      case ACTION_TYPES.UPDATED_STATU:
        message.success("Sözleşme durumu güncellendi.");
        onOperationExecuted();
        break;
      default:
        break;
    }
  }, [process]);

  const handleActions = (key, record) => {
    switch (key) {
      case "detail":
        if (record.state === RECORD_STATE.ACTIVE)
          history.push(`${match.path}/${record.id}/detay`);
        else history.push(`${match.path}/${record.id}/arsiv`);
        break;
      case "edit":
        history.push(`${match.path}/${record.id}/duzenle`);
        break;
      case "remove":
        Modal.confirm({
          title: "Sil",
          content: "Bu sözleşmeyi silmek istediğinize emin misiniz?",
          okText: "Evet",
          cancelText: "İptal",
          onOk: () =>
            actions.remove({ id: record.id, version: record.version }),
        });
        break;
      case "copy":
        history.push(`${match.path}/${record.id}/kopyala`);
        break;
      case "restore":
        actions.restore({ id: record.id, version: record.version });
        break;
      case "abolish":
        setAbolishModalvisible(true);
        setSelectedRecord(record);
        break;
      case "undo-abolish":
        actions.updateStatu({
          id: record.id,
          contractStatu: "ACTIVE",
          dateOfRescission: null,
        });
        break;
    }
  };

  return (
    <>
      <AbolishModal
        record={selectedRecord}
        visible={abolishModalVisible}
        onSubmit={() => {
          onOperationExecuted();
          setAbolishModalvisible(false);
        }}
        onCancel={() => {
          setAbolishModalvisible(false);
        }}
      />
      <Spin
        spinning={[
          ACTION_TYPES.REMOVING_DATA,
          ACTION_TYPES.RESTORING_DATA,
          ACTION_TYPES.UPDATING_STATU,
          ACTION_TYPES.REMOVING_DATA,
        ].includes(process)}
      >
        <Dropdown
          trigger="click"
          placement="bottomRight"
          overlay={
            <Menu onClick={(item) => handleActions(item.key, record)}>
              <Menu.Item key="detail">
                <FontAwesomeIcon
                  icon={["fas", "eye"]}
                  style={{ marginRight: 8, width: 24 }}
                />
                Detaylar
              </Menu.Item>
              {record.state === RECORD_STATE.DELETED &&
              AuthCheck(
                abilities,
                AUTH_ACTIONS.RESTORE_ARCHIVE,
                "Sözleşmeler"
              ) ? (
                <Menu.Item key="restore">
                  <FontAwesomeIcon
                    icon={["fas", "recycle"]}
                    style={{ marginRight: 8, width: 24 }}
                  />
                  Geri Al
                </Menu.Item>
              ) : null}
              {record.contractStatu === "ACTIVE" &&
              record.state === RECORD_STATE.ACTIVE &&
              AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Sözleşmeler") ? (
                <Menu.Item key="edit">
                  <FontAwesomeIcon
                    icon={["fas", "edit"]}
                    style={{ marginRight: 8, width: 24 }}
                  />
                  Düzenle
                </Menu.Item>
              ) : null}
              {AuthCheck(abilities, AUTH_ACTIONS.NEW_RECORD, "Sözleşmeler") ? (
                <Menu.Item key="copy">
                  <FontAwesomeIcon
                    icon={["fas", "copy"]}
                    style={{ marginRight: 8, width: 24 }}
                  />
                  Kopyala
                </Menu.Item>
              ) : null}
              {record.state === RECORD_STATE.ACTIVE &&
              AuthCheck(abilities, AUTH_ACTIONS.DELETE, "Sözleşmeler") ? (
                <Menu.Item key="remove">
                  <FontAwesomeIcon
                    icon={["far", "trash-alt"]}
                    style={{ marginRight: 8, width: 24 }}
                  />
                  Sil
                </Menu.Item>
              ) : null}
              {record.contractStatu === "ACTIVE" &&
              record.state === RECORD_STATE.ACTIVE &&
              AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Sözleşmeler") ? (
                <Menu.Item key="abolish">
                  <FontAwesomeIcon
                    icon={["fas", "ban"]}
                    style={{ marginRight: 8, width: 24 }}
                  />
                  Feshet
                </Menu.Item>
              ) : null}
              {record.contractStatu === "ABOLISH" &&
              record.state === RECORD_STATE.ACTIVE &&
              AuthCheck(abilities, AUTH_ACTIONS.WRITE, "Sözleşmeler") ? (
                <Menu.Item key="undo-abolish">
                  <FontAwesomeIcon
                    icon={["fas", "undo"]}
                    style={{ marginRight: 8, width: 24 }}
                  />
                  Feshi Geri Al
                </Menu.Item>
              ) : null}
            </Menu>
          }
        >
          <Button>
            <FontAwesomeIcon icon={["fas", "ellipsis-h"]} />
          </Button>
        </Dropdown>
      </Spin>
    </>
  );
}
